// src/components/AgeretProductDetail.jsx

import React, { useState } from "react";
import "../assets/css/AgeretProductDetail.css";
import mainImage from "../assets/images/New-Products/Biouv-32.jpg";
import thumb1 from "../assets/images/All-Products/BioUV-32-SPF.png";
import thumb2 from "../assets/images/New-Products/Biouv-32.jpg";
import thumb3 from "../assets/images/All-Products/BioUV-32-SPF.png";
import howToUseThumb from "../assets/images/skin-breadcrum.jpg";
import howToUseVideo from "../assets/Video/meical video.mp4";
import BredcrumpImage from "../assets/images/skin-breadcrum.jpg";
import BreadcrumbSection from "./BreadcrumbSection";



const AgeretProductDetails = () => {
  const [selectedImage, setSelectedImage] = useState(mainImage);
  const [activeTab, setActiveTab] = useState("benefits");
  const [showVideo, setShowVideo] = useState(false);

  return (
    <>

      <BreadcrumbSection
        title="Empowering Confidence Through Skin Health."
        // subtitle="Committed to Excellence:"
        breadcrumbItems={[
          { label: "Home", to: "/" }, { label: "Skin Care", to: "/Skin-Care-Products" },

        ]}
        backgroundImage={BredcrumpImage}
      />

      <section className="product-details-section">

        <div className="container product-container">
          {/* Product Image and Details */}
          <div className="product-info">
            <div className="product-image-section">
              <img src={selectedImage} alt="Ageret Product" className="main-image" />
              <div className="thumbnail-row">
                {[thumb2].map((img, i) => (
                  <img
                    key={i}
                    src={img}
                    alt={`Thumbnail ${i + 1}`}
                    className={`thumbnail ${selectedImage === img ? "active-thumb" : ""}`}
                    onClick={() => setSelectedImage(img)}
                  />
                ))}
              </div>
            </div>

            <div className="product-description">
              <h2>BioUV 32</h2>
              <p className="sub-heading text-muted">ULTIMATE PROTECTION WITH FLAWLESS COVERAGE </p>
              <h5>Product Overview</h5>
              <p>
                BioUV 32 SPF is a tinted matte finish sunscreen lotion.
                It possesses encapsulated Iron Oxide which protects the skin from High Energy Visible Light.
                It has micronized form of Zinc Oxide and Titanium Dioxide which acts as SPF Booster.
                It ensures excellent protection against UVA-UVB rays. It has Resveratrol which has Anti-Ageing properties.
              </p>
            </div>
          </div>

          {/* How To Use Section */}
          {/* <div className="how-to-use-section" data-aos="fade-up">
            <div
              className="how-to-use-content"
              style={{
                backgroundImage: `url(${howToUseThumb})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div className="text-content">
                <h3>
                  How To Use <span className="highlight">BioUV 32 ?</span>
                </h3>
                <p>
                Apply sunscreen generously to protect your face, arms and over your trunk from harmful UV rays and prevent sun damage
                </p>
              </div>
              <div className="video-thumbnail-wrapper" onClick={() => setShowVideo(true)}>
                <div className="video-thumbnail">
                  <i className="bi bi-play-fill play-icon"></i>
                </div>
              </div>
            </div>
          </div> */}

          {/* Video Popup Modal */}
          {showVideo && (
            <div className="video-popup">
              <div className="video-container">
                <video controls autoPlay>
                  <source src={howToUseVideo} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>

                {/* Uncomment this block to use YouTube later */}
                {/*
              <iframe
                src="https://www.youtube.com/embed/VIDEO_ID?autoplay=1"
                title="How to Use Ageret"
                frameBorder="0"
                allow="autoplay; encrypted-media"
                allowFullScreen
              ></iframe>
              */}

                <button className="close-btn" onClick={() => setShowVideo(false)}>
                  &times;
                </button>
              </div>
            </div>
          )}

          {/* Accordion Section */}
          <div className="accordion-section">
            <div className="accordion-tabs">
              {["benefits", "application", "ingredients"].map((tab) => (
                <button
                  key={tab}
                  className={`accordion-tab ${activeTab === tab ? "active" : ""}`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab === "benefits"
                    ? "BENEFITS"
                    : tab === "application"
                      ? "APPLICATION GUIDELINES"
                      : tab === "ingredients"
                        ? "INGREDIENTS"
                        : "BEFORE–AFTER"}
                </button>
              ))}
            </div>

            <div className="accordion-content">
              {activeTab === "benefits" && (
                <div className="tab-content fade-in">
                  <ul>
                    <li>BioUV 32 SPF Lotion provides physical protection against UVA-UVB sun rays and High Energy Visible Light (HEVL).</li>
                    <li>It blocks harmful UVB rays.</li>
                    <li>It is non greasy, tinted matte finish which suits all skin tones.</li>
                    <li>BioUV 32 SPF lotion is light-weight, long-lasting, non-comedogenic and hypoallergenic.</li>
                    <li>This lotion is paraben free, sulphate free, phthalate free, petroleum oil free and GMO free.</li>
                  </ul>


                </div>
              )}
              {activeTab === "application" && (
                <div className="tab-content fade-in">
                  <p>
                    <ul>
                      <li>Take sufficient quantity of BioUV 32 SPF Lotion and apply liberally to cover the exposed areas.</li>
                      <li>Apply it 15–20 minutes before sun exposure.</li>
                      <li>Reapplication of lotion is needed after every 2–3 hours.</li>
                      <li>Avoid contact with eyes.</li>
                    </ul>


                  </p>
                </div>
              )}
              {activeTab === "ingredients" && (
                <div className="tab-content fade-in">
                  <p>
                    <ul>
                      <li><strong>Iron oxide 3%:</strong> Provides effective protection against HEVL. Tinted mineral sunscreens offer better protection than non-tinted ones by shielding from UV and visible light. Sunscreens with iron oxides help in treating melasma and prevent hyperpigmentation, especially in dark-skinned individuals (Fitzpatrick skin types IV–VI).</li>

                      <li><strong>Zinc Oxide 6%:</strong> Blocks both UVA & UVB radiations and also contributes to blue light protection.</li>

                      <li><strong>Titanium dioxide 5%:</strong> Along with ZnO, provides broad-spectrum protection against UVA & UVB radiations.</li>

                      <li><strong>Aloe vera:</strong> Gives soothing and moisturizing effect to the skin and has anti-inflammatory properties.</li>

                      <li><strong>Oat meal extract:</strong> Contains various phenols that exert antioxidant and anti-inflammatory properties.</li>

                      <li><strong>Resveratrol:</strong> A potent antioxidant that protects from environmental and UV-related damage and helps brighten the skin.</li>
                    </ul>

                  </p>
                </div>
              )}



            </div>
          </div>
        </div>
      </section>

    </>
  );
};

export default AgeretProductDetails;
